export const getValueByPath = (obj, path) => {
  const parts = path.split('.');
  let value = obj;

  for (let i = 0; i < parts.length; i++) {
    value = value[parts[i]];
    if (!value) break;
  }

  return value;
};
